import React from 'react'

function LeftContent() {
	return ( 
		<div className="Panel-left">
			<div className="plant"></div>
	  	</div>
	  )
}

export default LeftContent

